export function validateJobPosition(job_position) {
  if (!job_position) return "Select Job Position";
  return "";
}
